<template>
  <section class="dp-layout">
    <section class="dp-left">
      <DepartmentPane directory-scope="school" @tree-node-click="treeNodeClick" :type="1"></DepartmentPane>
    </section>
    <section class="dp-right">
      <div class="toolbar-filter-bar">
        <el-form :inline="true" :model="filters" class="toolbar-filter-form">
          <div class="toolbar-filter-fields">
            <el-form-item label="登记日期">
              <el-date-picker v-model="filters.registerDate" type="date" value-format="yyyy-MM-dd" placeholder="日期"
                class="toolbar-field-w-date"></el-date-picker>
            </el-form-item>
            <el-form-item label="时间段">
              <el-select v-model="filters.timeSlotId" placeholder="必选" class="toolbar-field-w-slot"
                @change="onTimeSlotChange">
                <el-option v-for="s in slotOptions" :key="s.Id" :label="formatTeacherPatrolSlotLabel(s)"
                  :value="s.Id"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="分组">
              <el-select v-model="filters.groupId" clearable placeholder="全部" class="toolbar-field-w-md">
                <el-option v-for="g in groupOptions" :key="g.Id" :label="g.GroupName" :value="g.Id"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" size="small" icon="el-icon-search" @click="handleQuery">查询</el-button>
            </el-form-item>
          </div>
          <div class="toolbar-filter-actions">
            <el-button v-for="item in actionButtonList" :key="item.id || item.Func"
              size="small"
              :type="toolbarBtnType(item)"
              :icon="toolbarBtnIcon(item)"
              :loading="!!item.loading"
              @click="btnClick(item)">{{ item.name }}</el-button>
          </div>
        </el-form>
      </div>
      <div class="summary-tip">班牌数 = 分组内班牌总数；登记次数 = 登记记录条数（每轮每块班牌最多 1）；人次 = 该轮去重教师数。点击数字可查看明细。</div>

      <div class="tbl-scroll-host">
      <!-- 多级表头勿用 fixed：与 split-layout 对 el-table 的 flex 限高冲突，会导致表头/行错位。最后更新：2026-09-13 -->
      <el-table ref="summaryTable" :data="rows" v-loading="listLoading" style="width: 100%;" stripe border
        height="100%">
        <el-table-column label="分组" min-width="120" align="center" header-align="center"
          show-overflow-tooltip>
          <template slot-scope="scope">{{ scope.row.GroupName || scope.row.groupName }}</template>
        </el-table-column>
        <el-table-column label="班牌数" width="80" align="center" header-align="center">
          <template slot-scope="scope">{{ getTerminalCount(scope.row) }}</template>
        </el-table-column>
        <el-table-column label="合计" align="center" header-align="center">
          <el-table-column label="登记次数" width="90" align="center" header-align="center">
            <template slot-scope="scope">
              <count-link :value="getTotalCount(scope.row)" @click="openDetail(scope.row, 0, 'count')" />
            </template>
          </el-table-column>
          <el-table-column label="人次" width="70" align="center" header-align="center">
            <template slot-scope="scope">
              <count-link :value="getTotalPersonCount(scope.row)" @click="openDetail(scope.row, 0, 'person')" />
            </template>
          </el-table-column>
        </el-table-column>
        <el-table-column v-for="col in roundColumns" :key="'round-' + col" :label="'第' + col + '次'" align="center"
          header-align="center">
          <el-table-column label="登记" width="70" align="center" header-align="center">
            <template slot-scope="scope">
              <count-link :value="getRoundCount(scope.row, col)" @click="openDetail(scope.row, col, 'count')" />
            </template>
          </el-table-column>
          <el-table-column label="人次" width="70" align="center" header-align="center">
            <template slot-scope="scope">
              <count-link :value="getRoundPersonCount(scope.row, col)" @click="openDetail(scope.row, col, 'person')" />
            </template>
          </el-table-column>
        </el-table-column>
        <el-table-column label="操作" width="80" align="center" header-align="center">
          <template slot-scope="scope">
            <el-button type="text" @click="openAllDetail(scope.row)">明细</el-button>
          </template>
        </el-table-column>
      </el-table>
      </div>

      <div class="pagination-container">
        <el-pagination layout="total, prev, pager, next" :current-page="page" :page-size="pageSize"
          :total="total" style="float: right" @current-change="handleCurrentChange"></el-pagination>
      </div>

      <el-dialog  :title="detailTitle" :visible.sync="detailDialogVisible" width="920px" append-to-body>
        <el-table :data="detailRows" v-loading="detailLoading" stripe max-height="420">
          <el-table-column prop="TerminalName" label="班牌" width="" align="center" header-align="center"
            show-overflow-tooltip></el-table-column>
          <el-table-column prop="DepartmentName" label="班级" width="" align="center" header-align="center"
            show-overflow-tooltip></el-table-column>
          <el-table-column prop="TeacherName" label="教师" width="" align="center" header-align="center"
            show-overflow-tooltip></el-table-column>
          <el-table-column label="第几次" width="" align="center" header-align="center">
            <template slot-scope="scope">第{{ scope.row.RoundNumber }}次</template>
          </el-table-column>
          <el-table-column label="登记时间" width="" align="center" header-align="center" show-overflow-tooltip>
            <template slot-scope="scope">{{ formatDateTime(scope.row.RegisterTime) }}</template>
          </el-table-column>
        </el-table>
        <div class="detail-pagination">
          <el-pagination layout="total, prev, pager, next" :current-page="detailPage" :page-size="detailPageSize"
            :total="detailTotal" @current-change="onDetailPageChange"></el-pagination>
        </div>
        <div slot="footer">
          <el-button type="primary" @click="detailDialogVisible = false">关闭</el-button>
        </div>
      </el-dialog>
    </section>
  </section>
</template>

<script>
import {
  getTeacherPatrolSummary,
  getTeacherPatrolRecordPage,
  exportTeacherPatrolSummary,
  getTeacherPatrolGroupOptions,
  getTeacherPatrolTimeSlotOptions,
  formatTeacherPatrolSlotLabel,
  clearTeacherPatrolListTable,
  onTeacherPatrolSchoolChange
} from "@/api/teacherPatrol";
import { treeNodeDeptId } from '../../utils/deptCascaderProps';
import { getButtonList } from "../../promissionRouter";
import DepartmentPane from "../../components/DepartmentPane";
import toolbarFilterBarMixin from "@/mixins/toolbarFilterBarMixin";

/** 汇总数字：大于 0 时可点击 */
const CountLink = {
  name: "CountLink",
  props: {
    value: { type: Number, default: 0 }
  },
  render(h) {
    const val = this.value || 0;
    if (val > 0) {
      return h("el-link", {
        props: { type: "primary", underline: false },
        on: { click: () => this.$emit("click") }
      }, String(val));
    }
    return h("span", { class: "count-zero" }, "0");
  }
};

export default {
  mixins: [toolbarFilterBarMixin],
  components: { DepartmentPane, CountLink },
  data() {
    const today = new Date();
    const dateStr = today.getFullYear() + "-" +
      String(today.getMonth() + 1).padStart(2, "0") + "-" +
      String(today.getDate()).padStart(2, "0");
    return {
      filters: {
        registerDate: dateStr,
        timeSlotId: null,
        groupId: null
      },
      actionButtonList: [],
      DepartmentId: 0,
      slotOptions: [],
      groupOptions: [],
      rows: [],
      total: 0,
      roundColumns: [],
      page: 1,
      pageSize: 10,
      listLoading: false,
      detailDialogVisible: false,
      detailTitle: "",
      detailLoading: false,
      detailRows: [],
      detailPage: 1,
      detailPageSize: 10,
      detailTotal: 0,
      detailContext: null
    };
  },
  mounted() {
    const routers = window.localStorage.router ? JSON.parse(window.localStorage.router) : [];
    const buttonList = getButtonList(this.$route.path, routers);
    this.actionButtonList = buttonList.filter(b => b.Func !== "handleQuery");
    this.applyRouteQuery();
  },
  methods: {
    formatTeacherPatrolSlotLabel,
    btnClick(item) {
      if (item.Func && typeof this[item.Func] === "function") {
        this[item.Func](item);
      }
    },
    applyRouteQuery() {
      const q = this.$route.query || {};
      if (q.registerDate) this.filters.registerDate = q.registerDate;
      if (q.timeSlotId) this.filters.timeSlotId = Number(q.timeSlotId);
      if (q.groupId) this.filters.groupId = Number(q.groupId);
    },
    async treeNodeClick(data) {
      onTeacherPatrolSchoolChange(this, treeNodeDeptId(data));
      this.syncRoundColumns(0);
      await this.loadOptions();
      this.handleQuery();
    },
    async loadOptions() {
      if (!this.DepartmentId) return;
      const [slotRes, groupRes] = await Promise.all([
        getTeacherPatrolTimeSlotOptions({ departmentId: this.DepartmentId }),
        getTeacherPatrolGroupOptions({ departmentId: this.DepartmentId })
      ]);
      if (slotRes.data.success) {
        this.slotOptions = slotRes.data.response || [];
        const slotIds = this.slotOptions.map(s => s.Id);
        if (this.slotOptions.length > 0) {
          if (!this.filters.timeSlotId || slotIds.indexOf(this.filters.timeSlotId) < 0) {
            this.filters.timeSlotId = this.slotOptions[0].Id;
          }
        } else {
          this.filters.timeSlotId = null;
        }
      } else {
        this.slotOptions = [];
        this.filters.timeSlotId = null;
      }
      if (groupRes.data.success) {
        this.groupOptions = groupRes.data.response || [];
      } else {
        this.groupOptions = [];
      }
      if (this.filters.groupId) {
        const groupIds = this.groupOptions.map(g => g.Id);
        if (groupIds.indexOf(this.filters.groupId) < 0) {
          this.filters.groupId = null;
        }
      }
      this.syncRoundColumns();
    },
    getSelectedSlotMaxRound() {
      if (!this.filters.timeSlotId || !this.slotOptions.length) return 0;
      const slot = this.slotOptions.find(s => s.Id === this.filters.timeSlotId);
      if (!slot) return 0;
      return slot.MaxRoundCount != null ? slot.MaxRoundCount : (slot.maxRoundCount || 0);
    },
    syncRoundColumns(maxRound) {
      const count = maxRound != null && maxRound > 0 ? maxRound : this.getSelectedSlotMaxRound();
      const cols = [];
      for (let i = 1; i <= count; i++) {
        cols.push(i);
      }
      this.roundColumns = cols;
      this.$nextTick(() => this.relayoutSummaryTable());
    },
    /** 轮次列变化后重算表头宽度，避免错位。最后更新：2026-09-13 */
    relayoutSummaryTable() {
      const table = this.$refs.summaryTable;
      if (table && typeof table.doLayout === "function") {
        table.doLayout();
      }
    },
    onTimeSlotChange() {
      this.syncRoundColumns();
      this.page = 1;
    },
    getMapField(row, camelKey, pascalKey) {
      const map = row[camelKey] || row[pascalKey];
      return map || {};
    },
    getTotalCount(row) {
      return row.totalCount != null ? row.totalCount : (row.TotalCount || 0);
    },
    getTotalPersonCount(row) {
      return row.totalPersonCount != null ? row.totalPersonCount : (row.TotalPersonCount || 0);
    },
    getTerminalCount(row) {
      return row.terminalCount != null ? row.terminalCount : (row.TerminalCount || 0);
    },
    getRoundCount(row, round) {
      const map = this.getMapField(row, "roundCounts", "RoundCounts");
      return map[round] || map[String(round)] || 0;
    },
    getRoundPersonCount(row, round) {
      const map = this.getMapField(row, "roundPersonCounts", "RoundPersonCounts");
      return map[round] || map[String(round)] || 0;
    },
    formatDateTime(val) {
      if (!val) return "";
      return String(val).replace("T", " ").substring(0, 19);
    },
    buildExportParams() {
      return {
        departmentId: this.DepartmentId,
        registerDate: this.filters.registerDate,
        timeSlotId: this.filters.timeSlotId,
        groupId: this.filters.groupId || 0
      };
    },
    handleQuery() {
      this.page = 1;
      this.loadSummary();
    },
    async exportExcel() {
      if (!this.DepartmentId) {
        this.$message.warning("请先选择学校");
        return;
      }
      if (!this.filters.timeSlotId) {
        this.$message.warning("请选择巡检时间段");
        return;
      }
      try {
        const res = await exportTeacherPatrolSummary(this.buildExportParams());
        const blob = new Blob([res.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = "教师巡检汇总_" + new Date().getTime() + ".xlsx";
        link.click();
        window.URL.revokeObjectURL(url);
      } catch (e) {
        this.$message.error("导出失败");
      }
    },
    handleCurrentChange(val) {
      this.page = val;
      this.loadSummary();
    },
    async loadSummary() {
      if (!this.DepartmentId) {
        clearTeacherPatrolListTable(this);
        this.syncRoundColumns(0);
        this.$message.warning("请先选择学校");
        return;
      }
      if (!this.filters.timeSlotId) {
        clearTeacherPatrolListTable(this);
        this.syncRoundColumns(0);
        this.$message.warning("请选择巡检时间段");
        return;
      }
      this.listLoading = true;
      try {
        const res = await getTeacherPatrolSummary({
          departmentId: this.DepartmentId,
          registerDate: this.filters.registerDate,
          timeSlotId: this.filters.timeSlotId,
          groupId: this.filters.groupId || 0,
          page: this.page,
          intPageSize: this.pageSize
        });
        if (res.data.success) {
          const data = res.data.response || {};
          this.rows = data.rows || data.Rows || [];
          this.total = data.rowCount != null ? data.rowCount : (data.RowCount || 0);
          const maxRound = data.maxRoundCount || data.MaxRoundCount || 0;
          this.syncRoundColumns(maxRound);
        } else {
          clearTeacherPatrolListTable(this);
          this.syncRoundColumns();
        }
      } finally {
        this.listLoading = false;
      }
    },
    openAllDetail(row) {
      this.openDetail(row, 0, "all");
    },
    openDetail(row, roundNumber, metricType) {
      const groupId = row.groupId || row.GroupId;
      const groupName = row.groupName || row.GroupName || "";
      let detailTitle = groupName;
      if (metricType === "all") {
        detailTitle += " · 全部登记明细";
      } else {
        const roundLabel = roundNumber > 0 ? "第" + roundNumber + "次" : "合计";
        const metricLabel = metricType === "person" ? "人次" : "登记次数";
        detailTitle += " · " + roundLabel + " · " + metricLabel + "明细";
      }
      this.detailContext = {
        groupId: groupId,
        groupName: groupName,
        roundNumber: roundNumber,
        metricType: metricType
      };
      this.detailTitle = detailTitle;
      this.detailPage = 1;
      this.detailDialogVisible = true;
      this.loadDetailList();
    },
    onDetailPageChange(page) {
      this.detailPage = page;
      this.loadDetailList();
    },
    async loadDetailList() {
      if (!this.detailContext || !this.DepartmentId) return;
      this.detailLoading = true;
      try {
        const para = {
          departmentId: this.DepartmentId,
          groupId: this.detailContext.groupId,
          timeSlotId: this.filters.timeSlotId,
          startDate: this.filters.registerDate,
          endDate: this.filters.registerDate,
          page: this.detailPage,
          intPageSize: this.detailPageSize
        };
        if (this.detailContext.roundNumber > 0) {
          para.roundNumber = this.detailContext.roundNumber;
        }
        const res = await getTeacherPatrolRecordPage(para);
        if (res.data.success) {
          this.detailRows = res.data.response.data || [];
          this.detailTotal = res.data.response.dataCount || 0;
        } else {
          this.detailRows = [];
          this.detailTotal = 0;
        }
      } finally {
        this.detailLoading = false;
      }
    }
  }
};
</script>

<style scoped>
.summary-tip {
  flex: 0 0 auto;
  color: #909399;
  font-size: 12px;
  margin: 0 0 12px;
  line-height: 1.4;
}

.detail-pagination {
  margin-top: 12px;
  display: flex;
  justify-content: flex-end;
}

.pagination-container {
  margin-top: 16px;
  overflow: hidden;
}

.count-zero {
  color: #c0c4cc;
}
</style>
